export default __webpack_public_path__ + "static/media/personal@3x.bd560cee.png";